import './Footer.css';

const IconInstagram = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

export default function Footer() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <div className="footer__brand-logo">🐾 Amanimal Shop</div>
          <p className="footer__brand-desc">
            Roupas confortáveis que salvam vidas. Canal de vendas da ONG Amanimal,
            dedicada ao resgate e adoção responsável de animais.
          </p>
        </div>

        <div className="footer__col">
          <h4>Loja</h4>
          <ul>
            <li><button onClick={() => scrollTo('produtos')}>Produtos</button></li>
            <li><button onClick={() => scrollTo('linha')}>Nossa Linha</button></li>
            <li><button onClick={() => scrollTo('como')}>Como Comprar</button></li>
          </ul>
        </div>

        <div className="footer__col">
          <h4>ONG</h4>
          <ul>
            <li><button onClick={() => scrollTo('missao')}>Nossa Missão</button></li>
            <li><button onClick={() => scrollTo('impacto')}>Nossa História</button></li>
            <li><button onClick={() => scrollTo('galeria')}>Galeria</button></li>
          </ul>
        </div>

        <div className="footer__col">
          <h4>Contato</h4>
          <ul>
            <li><a href="mailto:contato@amanimalshop.com.br">contato@amanimalshop.com.br</a></li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} Amanimal Shop — Todos os direitos reservados</p>
        <div className="footer__socials">
          <a href="https://www.instagram.com/amanimal_shop?igsh=OWdmNWkyYmFpYXFv" target="_blank" rel="noreferrer" aria-label="Instagram" className="footer__social-icon">
            <IconInstagram />
          </a>
        </div>
      </div>

      <div className="footer__singlec">
        <p>
          Developed by{' '}
          <a href="https://www.singlec.com.br" target="_blank" rel="noreferrer">singlec</a>
        </p>
      </div>
    </footer>
  );
}
